import { defineStore } from 'pinia';
import {
	LEFT_DRAWER_FOLDER_EXPLORER_WIDTH,
	LEFT_DRAWER_MAIN_MENU_WIDTH,
	LEFT_DRAWER_MINI_STATE,
	LEFT_DRAWER_OPEN_STATE,
	RIGHT_USER_ONLINE_DRAWER_MINI_STATE,
} from 'src/stores/userInterfaceState/localStorageKeys';

import type { UserInterfaceStateStoreState } from './interfaces';

const readNumberFromStorage = (key: string, defaultValue: number): number => {
	const serializedValue = localStorage.getItem(key);

	if (serializedValue === null) {
		return defaultValue;
	}

	const parsedValue = parseInt(serializedValue);

	return Number.isFinite(parsedValue) ? parsedValue : defaultValue;
};

const readBooleanFromStorage = (key: string, defaultValue: boolean): boolean => {
	const serializedValue = localStorage.getItem(key);

	if (serializedValue === null) {
		return defaultValue;
	}

	return /true/i.test(serializedValue);
};

const createDefaultState = (): UserInterfaceStateStoreState => ({
	folderExplorerWidth: readNumberFromStorage(LEFT_DRAWER_FOLDER_EXPLORER_WIDTH, 420),
	keyboardIsVisibleState: false,
	leftDrawerOpenState: readBooleanFromStorage(LEFT_DRAWER_OPEN_STATE, false),
	mainMenuDrawerWidth: readNumberFromStorage(LEFT_DRAWER_MAIN_MENU_WIDTH, 240),
	miniState: readBooleanFromStorage(LEFT_DRAWER_MINI_STATE, true),
	miniStateUserOnline: readBooleanFromStorage(RIGHT_USER_ONLINE_DRAWER_MINI_STATE, false),
	rightDrawerOpenState: false,
});

export const useUserInterfaceStateStore = defineStore('userInterfaceState', {
	actions: {
		setFolderExplorerWidth(folderExplorerWidth: number): void {
			localStorage.setItem(LEFT_DRAWER_FOLDER_EXPLORER_WIDTH, String(folderExplorerWidth));
			this.folderExplorerWidth = folderExplorerWidth;
		},
		setKeyboardIsVisibleState(keyboardIsVisibleState: boolean): void {
			this.keyboardIsVisibleState = keyboardIsVisibleState;
		},
		setLeftDrawerOpenState(leftDrawerOpenState: boolean): void {
			localStorage.setItem(LEFT_DRAWER_OPEN_STATE, JSON.stringify(leftDrawerOpenState));
			this.leftDrawerOpenState = leftDrawerOpenState;
		},
		setMainMenuDrawerWidth(mainMenuDrawerWidth: number): void {
			localStorage.setItem(LEFT_DRAWER_MAIN_MENU_WIDTH, String(mainMenuDrawerWidth));
			this.mainMenuDrawerWidth = mainMenuDrawerWidth;
		},
		setMiniState(miniState: boolean): void {
			localStorage.setItem(LEFT_DRAWER_MINI_STATE, JSON.stringify(miniState));
			this.miniState = miniState;
		},
		setMiniStateUserOnline(miniStateUserOnline: boolean): void {
			localStorage.setItem(RIGHT_USER_ONLINE_DRAWER_MINI_STATE, JSON.stringify(miniStateUserOnline));
			this.miniStateUserOnline = miniStateUserOnline;
		},
		setRightDrawerOpenState(rightDrawerOpenState: boolean): void {
			this.rightDrawerOpenState = rightDrawerOpenState;
		},
	},
	state: createDefaultState,
});
export * from './interfaces';
export * from './types';
